import PropTypes from 'prop-types';
import React from 'react';
import {
  Redirect,
} from 'react-router-dom';
import { connect } from 'react-redux';

import { isAuthorizedSelector } from '../redux/selectors';
import { consumeLoginRedirectFrom } from '../utils/redirects';

import Wrapper from './Wrapper';

/**
 * A simple SFC container is responsible for rendering the page containing the login form and
 * redirecting to the correct route when a user is authorized.
 * @param {Object} props The props passed to this component.
 * @param {Boolean} props.isAuthorized A boolean value indicating whether the use is authorized.
 */
export function LoginPage({
  isAuthorized,
  children,
}) {
  if (isAuthorized) {
    // This block runs after a succesful SSO ticket decoding. The redirectPath
    // will be saved in localstorage, so we should consume it.
    const redirectPath = consumeLoginRedirectFrom();

    return (
      <Redirect to={redirectPath} />
    );
  }

  return (
    <Wrapper>{children}</Wrapper>
  );
}

LoginPage.propTypes = {
  isAuthorized: PropTypes.bool.isRequired,
  children: PropTypes.node.isRequired,
};

/* istanbul ignore next */
function mapStateToProps(state) {
  return {
    isAuthorized: isAuthorizedSelector(state),
  };
}

export default connect(mapStateToProps)(LoginPage);



// WEBPACK FOOTER //
// ./features/authentication/LoginPage/index.js